
import { SecretaryMessageState } from "../interfaces/secreteryMessage"
import { Types } from "../types"
import { SecretaryMessageActions } from "../types/secreteryMessage/actionsTypes"

const initialState: SecretaryMessageState = {
    getNumberByCustomerByIDPending: false,
    getNumberByCustomerByIDSuccess: false,
    getNumberByCustomerByIDError: '',
    dtoObj: [],

    saveNotePending: false,
    saveNoteSuccess: false,
    saveNoteError: '',


    getNotePending: false,
    getNoteSuccess: false,
    getNoteError: '',
    details: [],

    searchPending: false,
    searchSuccess: false,
    searchError: '',

    updateStartPending: false,
    updateStartSuccess: false,
    updateStartError: '',
    statusUpdate: {},


    getCustomerLinePending: false,
    getCustomerLineSuccess: false,
    getCustomerLineError: '',
    Lines: []
}

const secretaryMessageReducer = (state = initialState, action: SecretaryMessageActions) => {
    switch (action.type) {

        //Get************************************************************************************************
        case Types.GET_NUMBER_BY_REQUEST_ID_REQUEST:
            return {
                ...state,
                getNumberByCustomerByIDPending: true,
                getNumberByCustomerByIDSuccess: false,
                getNumberByCustomerByIDError: '',
                dtoObj: []
            }
        case Types.GET_NUMBER_BY_REQUEST_ID_SUCCESS:
            return {
                ...state,
                getNumberByCustomerByIDPending: false,
                getNumberByCustomerByIDSuccess: true,
                getNumberByCustomerByIDError: '',
                dtoObj: action.payload.params
            }
        case Types.GET_NUMBER_BY_REQUEST_ID_ERROR:
            return {
                ...state,
                getNumberByCustomerByIDPending: false,
                getNumberByCustomerByIDSuccess: false,
                getNumberByCustomerByIDError: action.payload,
                dtoObj: []
            }
        //Save**************************************************************************************************
        case Types.SECRETARY_MESSAGE_SAVE_REQUEST:
            return {
                ...state,
                saveNotePending: true,
                saveNoteSuccess: false,
                saveNoteError: ''
            }
        case Types.SECRETARY_MESSAGE_SAVE_SUCCESS:
            return {
                ...state,
                saveNotePending: false,
                saveNoteSuccess: true,
                saveNoteError: ''
            }
        case Types.SECRETARY_MESSAGE_SAVE_ERROR:
            return {
                ...state,
                saveNotePending: false,
                saveNoteSuccess: false,
                saveNoteError: action.payload,
            }

        //GetNote*********************************************************************************************
        case Types.SECRETARY_MESSAGE_GET_NOTE_REQUEST:
            return {
                ...state,
                getNotePending: true,
                getNoteSuccess: false,
                getNoteError: '',
                details: []
            }
        case Types.SECRETARY_MESSAGE_GET_NOTE_SUCCESS:
            return {
                ...state,
                getNotePending: false,
                getNoteSuccess: true,
                getNoteError: '',
                details: action?.payload?.params
            }
        case Types.SECRETARY_MESSAGE_GET_NOTE_ERROR:
            return {
                ...state,
                getNotePending: false,
                getNoteSuccess: false,
                getNoteError: action.payload,
                details: []
            }

        //Search**************************************************************************************************
        case Types.SECRETARY_MESSAGE_SEARCH_REQUEST:
            return {
                ...state,
                searchPending: true,
                searchSuccess: false,
                searchError: '',
                dtoObj: []
            }
        case Types.SECRETARY_MESSAGE_SEARCH_SUCCESS:
            return {
                ...state,
                searchPending: false,
                searchSuccess: true,
                searchError: '',
                dtoObj: action.payload.params
            }
        case Types.SECRETARY_MESSAGE_SEARCH_ERROR:
            return {
                ...state,
                searchPending: false,
                searchSuccess: false,
                searchError: action.payload,
                dtoObj: []
            }
        ///updateStar**********************************************************************************************
        case Types.SECRETARY_MESSAGE_UPDATE_STAR_REQUEST:
            return {
                ...state,
                updateStartPending: true,
                updateStartSuccess: false,
                updateStartError: '',
                statusUpdate: {}
            }
        case Types.SECRETARY_MESSAGE_UPDATE_STAR_SUCCESS:
            return {
                ...state,
                updateStartPending: false,
                updateStartSuccess: true,
                updateStartError: '',
                statusUpdate: action?.payload
            }
        case Types.SECRETARY_MESSAGE_UPDATE_STAR_ERROR:
            return {
                ...state,
                updateStartPending: false,
                updateStartSuccess: false,
                updateStartError: action.payload,
                statusUpdate: {}
            }
        //getLinrByID********************************************************************************************
        case Types.SECRETARY_GET_CUSTOMER_LINES_REQUEST:
            return {
                ...state,
                getCustomerLinePending: true,
                getCustomerLineSuccess: false,
                getCustomerLineError: '',
                Lines: []
            }
        case Types.SECRETARY_GET_CUSTOMER_LINES_SUCCESS:
            return {
                ...state,
                getCustomerLinePending: false,
                getCustomerLineSuccess: true,
                getCustomerLineError: '',
                Lines: action.payload.params
            }
        case Types.SECRETARY_GET_CUSTOMER_LINES_ERROR:
            return {
                ...state,
                getCustomerLinePending: false,
                getCustomerLineSuccess: false,
                getCustomerLineError: action.payload,
                Lines: []
            }
        //Reset****************************************************************************************************

        case Types.SET_RESET_SECRETARY_MESSAGE_PROPS:
            return {
                ...state,
                // getNumberByCustomerByIDPending: false,
                // getNumberByCustomerByIDSuccess: false,
                // getNumberByCustomerByIDError: '',
                // dtoObj: [],

                // saveNotePending: false,
                // saveNoteSuccess: false,
                // saveNoteError: '',


                // getNotePending: false,
                // getNoteSuccess: false,
                // getNoteError: '',
                // details: [],

                // updateStartPending: false,
                // updateStartSuccess: false,
                // updateStartError: '',
                // statusUpdate: {},

                // getCustomerLinePending: false,
                // getCustomerLineSuccess: false,
                // getCustomerLineError: '',
                // Lines: []
                updateStartSuccess: false

            }

        //***************************************************************************************************** */    
        default:
            return {
                ...state
            }
    }
}
export default secretaryMessageReducer